import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500">当下最火的漫画话题标签，发现大家都在聊什么</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <span
              key={topic.id}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium cursor-pointer hover:opacity-80 transition-opacity ${topic.color}`}
            >
              {topic.name}
              <span className="text-xs opacity-70">{topic.heat}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}